








import { Component, Vue } from 'vue-property-decorator';
import { StateManager, ILog } from '@/services/StateManager';
import * as Helper from '@/helpers/Utils';

@Component<MyOrders>({
  mounted() {
    Helper.Utils.scrollToBottom('console');
  },
  updated() {
    Helper.Utils.scrollToBottom('console');
  },
})
export default class MyOrders extends Vue {
  private state = StateManager.GetInstance().GetState();

  get logs(): ILog[] {
    return this.state.logs;
  }
}
